import { TYPE_INSTANCE1 } from "App/constants";
import { fetchDataPost } from "App/utils/helpers";
import { useState, useEffect } from "react";

const useSelectOptionPost = (
  withSearch = false,
  url = "/formula/listformula",
  type = TYPE_INSTANCE1,
  val = "id",
  label = "name",
  response = "body",
  data = {},
  options = {}
) => {
  const DEFAULT_OPTION = withSearch
    ? []
    : [
        {
          label: "Pilih",
          value: "",
        },
      ];

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await fetchDataPost(type, url, response, data, options);
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: "",
                label: "Pilih",
              },
            ];
        res.map((item) => {
          return data.push({
            value: item[val],
            label: item[label],
          });
        });

        setState(data);
      }
    })();
  }, [withSearch, url, type, val, label, response]); // eslint-disable-line react-hooks/exhaustive-deps

  return state;
};

export default useSelectOptionPost;
